import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs, pricingContent } from '../data/mock';
import { ExternalLink } from 'lucide-react';

const FAQSection = () => {
  return (
    <section id="faq" className="py-20 lg:py-28 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            よくあるご質問
          </h2>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-slate-50 border border-slate-200 rounded-xl overflow-hidden data-[state=open]:border-cyan-500"
            >
              <AccordionTrigger className="px-6 py-4 text-left text-slate-900 hover:text-cyan-600 hover:no-underline transition-colors [&[data-state=open]]:text-cyan-600">
                <span className="text-base font-medium pr-4">{faq.question}</span>
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-4">
                <p className="text-slate-600 leading-relaxed">
                  {faq.answer}
                </p>
                {faq.hasSampleLink && (
                  <a
                    href={pricingContent.sampleReportUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="sample_report__button inline-flex items-center gap-2 mt-3 text-cyan-600 hover:text-cyan-700 transition-colors text-sm font-medium"
                  >
                    <ExternalLink className="w-4 h-4" />
                    サンプルレポートを見る
                  </a>
                )}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;